// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "reporting/v1/reporting.proto" (package "reporting.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Internal apis for the reporting service
//
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { ReportingService } from "./reporting";
import type { ListScheduledReportsResponse } from "./reporting";
import type { ListScheduledReportsRequest } from "./reporting";
import type { GetScheduledReportResponse } from "./reporting";
import type { GetScheduledReportRequest } from "./reporting";
import type { DeleteScheduledReportResponse } from "./reporting";
import type { DeleteScheduledReportRequest } from "./reporting";
import type { UpdateScheduledReportResponse } from "./reporting";
import type { UpdateScheduledReportRequest } from "./reporting";
import type { CreateScheduledReportResponse } from "./reporting";
import type { CreateScheduledReportRequest } from "./reporting";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GenerateReportResponse } from "./reporting";
import type { GenerateReportRequest } from "./reporting";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service reporting.v1.ReportingService
 */
export interface IReportingServiceClient {
    /**
     * GenerateReport is used for pdf-previewing or manual scheduling
     *
     * @generated from protobuf rpc: GenerateReport(reporting.v1.GenerateReportRequest) returns (reporting.v1.GenerateReportResponse);
     */
    generateReport(input: GenerateReportRequest, options?: RpcOptions): UnaryCall<GenerateReportRequest, GenerateReportResponse>;
    /**
     * @generated from protobuf rpc: CreateScheduledReport(reporting.v1.CreateScheduledReportRequest) returns (reporting.v1.CreateScheduledReportResponse);
     */
    createScheduledReport(input: CreateScheduledReportRequest, options?: RpcOptions): UnaryCall<CreateScheduledReportRequest, CreateScheduledReportResponse>;
    /**
     * @generated from protobuf rpc: UpdateScheduledReport(reporting.v1.UpdateScheduledReportRequest) returns (reporting.v1.UpdateScheduledReportResponse);
     */
    updateScheduledReport(input: UpdateScheduledReportRequest, options?: RpcOptions): UnaryCall<UpdateScheduledReportRequest, UpdateScheduledReportResponse>;
    /**
     * @generated from protobuf rpc: DeleteScheduledReport(reporting.v1.DeleteScheduledReportRequest) returns (reporting.v1.DeleteScheduledReportResponse);
     */
    deleteScheduledReport(input: DeleteScheduledReportRequest, options?: RpcOptions): UnaryCall<DeleteScheduledReportRequest, DeleteScheduledReportResponse>;
    /**
     * @generated from protobuf rpc: GetScheduledReport(reporting.v1.GetScheduledReportRequest) returns (reporting.v1.GetScheduledReportResponse);
     */
    getScheduledReport(input: GetScheduledReportRequest, options?: RpcOptions): UnaryCall<GetScheduledReportRequest, GetScheduledReportResponse>;
    /**
     * @generated from protobuf rpc: ListScheduledReports(reporting.v1.ListScheduledReportsRequest) returns (reporting.v1.ListScheduledReportsResponse);
     */
    listScheduledReports(input: ListScheduledReportsRequest, options?: RpcOptions): UnaryCall<ListScheduledReportsRequest, ListScheduledReportsResponse>;
}
/**
 * @generated from protobuf service reporting.v1.ReportingService
 */
export class ReportingServiceClient implements IReportingServiceClient, ServiceInfo {
    typeName = ReportingService.typeName;
    methods = ReportingService.methods;
    options = ReportingService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * GenerateReport is used for pdf-previewing or manual scheduling
     *
     * @generated from protobuf rpc: GenerateReport(reporting.v1.GenerateReportRequest) returns (reporting.v1.GenerateReportResponse);
     */
    generateReport(input: GenerateReportRequest, options?: RpcOptions): UnaryCall<GenerateReportRequest, GenerateReportResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GenerateReportRequest, GenerateReportResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateScheduledReport(reporting.v1.CreateScheduledReportRequest) returns (reporting.v1.CreateScheduledReportResponse);
     */
    createScheduledReport(input: CreateScheduledReportRequest, options?: RpcOptions): UnaryCall<CreateScheduledReportRequest, CreateScheduledReportResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateScheduledReportRequest, CreateScheduledReportResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateScheduledReport(reporting.v1.UpdateScheduledReportRequest) returns (reporting.v1.UpdateScheduledReportResponse);
     */
    updateScheduledReport(input: UpdateScheduledReportRequest, options?: RpcOptions): UnaryCall<UpdateScheduledReportRequest, UpdateScheduledReportResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateScheduledReportRequest, UpdateScheduledReportResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteScheduledReport(reporting.v1.DeleteScheduledReportRequest) returns (reporting.v1.DeleteScheduledReportResponse);
     */
    deleteScheduledReport(input: DeleteScheduledReportRequest, options?: RpcOptions): UnaryCall<DeleteScheduledReportRequest, DeleteScheduledReportResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteScheduledReportRequest, DeleteScheduledReportResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetScheduledReport(reporting.v1.GetScheduledReportRequest) returns (reporting.v1.GetScheduledReportResponse);
     */
    getScheduledReport(input: GetScheduledReportRequest, options?: RpcOptions): UnaryCall<GetScheduledReportRequest, GetScheduledReportResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetScheduledReportRequest, GetScheduledReportResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListScheduledReports(reporting.v1.ListScheduledReportsRequest) returns (reporting.v1.ListScheduledReportsResponse);
     */
    listScheduledReports(input: ListScheduledReportsRequest, options?: RpcOptions): UnaryCall<ListScheduledReportsRequest, ListScheduledReportsResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListScheduledReportsRequest, ListScheduledReportsResponse>("unary", this._transport, method, opt, input);
    }
}
